var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1114_5831",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 19,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0147 3H3V21H21.0147V3Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1114_5831)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5346 3C12.7504 3.05342 12.9908 3.04609 13.2155 3.07541C17.1124 3.58446 20.3002 6.7016 20.8967 10.5855L21.0083 11.4763C20.9931 11.8251 21.0287 12.1838 21.0083 12.5316C20.5443 20.4737 10.6603 23.9574 5.29116 18.0017C0.262999 12.4242 4.04054 3.41373 11.4799 3H12.5346ZM10.9651 8.56968C12.034 7.51597 14.4022 8.71894 13.3024 10.2571C12.4613 11.4333 10.8216 11.8848 10.9886 13.7445C11.0735 14.6877 12.3168 14.8967 12.631 14.0168C12.9452 13.137 12.7771 13.0935 13.5192 12.3729C14.6201 11.304 15.9686 10.531 15.3642 8.69956C14.3896 5.7453 8.92678 6.25016 8.53609 9.32278C8.44601 10.0319 8.85293 10.5776 9.59975 10.4922C10.3466 10.4069 10.4241 9.10334 10.9651 8.56968ZM11.7171 15.213C10.4586 15.412 10.6194 17.4911 12.1214 17.2706C13.4024 17.0826 13.1662 14.9841 11.7171 15.213Z",
    fill: "#FF9355"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/help-icon.1aced9cfff65bcba74fa329f89fdb859.svg";
export { ForwardRef as ReactComponent };